import _ from 'lodash';

const tooltipDirective = (app) => {
    app.directive('tooltip', {
        mounted(el, binding) {
            initTooltip(el, binding);
        },
        updated(el, binding) {
            el.querySelector('.tooltip-content').remove();

            initTooltip(el, binding);
        }
    });
};

function initTooltip(el, binding) {
    const tooltip = document.createElement('div');
    tooltip.className = 'tooltip-content';
    tooltip.innerHTML = _.isObject(binding.value) ? binding.value.text : binding.value;

    tooltip.setAttribute('role', 'tooltip');

    el.style.position = 'relative';
    // mark element for tooltip CSS hover/display handling
    el.classList.add('with-tooltip');

    el.appendChild(tooltip);

    const position = binding.value.position || 'top';
    el.classList.add(`tooltip--${position}`);

    el.addEventListener('mouseenter', () => {
        tooltip.style.display = !tooltip.innerHTML ? 'none' : 'inline-block';
    });

    el.addEventListener('mouseleave', () => {
        tooltip.style.display = 'none';
    });
}

export default tooltipDirective;
